export default __webpack_public_path__ + "static/media/more_info_boost_areas.b3263051.png";